import { render, staticRenderFns } from "./preview-fba-shipment-modal.vue?vue&type=template&id=65db74fc&scoped=true&"
import script from "./preview-fba-shipment-modal.vue?vue&type=script&lang=js&"
export * from "./preview-fba-shipment-modal.vue?vue&type=script&lang=js&"
import style0 from "./preview-fba-shipment-modal.vue?vue&type=style&index=0&id=65db74fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db74fc",
  null
  
)

export default component.exports